// eslint-disable-next-line no-unused-vars
import { LeaderboardState } from '../types';
import '../../types';

/**
 * @param {LeaderboardState} draft - Draft state.
 * @param {object} payload - Action payload.
 * @param payload.seasonId
 */
export const setBettingOddsData = (draft, { ...data }) => {
    draft.bettingOdds.data = {...data} ?? [];
};
